import { i18next } from '@frontend/i18n';
import { useQueueStore } from '@frontend/queue';

/**
 * Helper utility to notify that AI Receptionist settings have changed.
 * This will trigger the active test call to end and display a banner message to the user.
 *
 * @example
 * ```tsx
 * import { notifyAiReceptionistSettingsChanged } from '@frontend/ai-receptionist-ui';
 *
 * // In a mutation's onSuccess callback:
 * const { mutate } = useMutation({
 *   mutationFn: updateSettings,
 *   onSuccess: () => {
 *     notifyAiReceptionistSettingsChanged(t('ai-receptionist.settings-changed-call-ended'));
 *   }
 * });
 * ```
 *
 * @param message - The message to display in the banner (should be i18n translated)
 * @param settingType - Optional identifier for the type of setting that changed
 */
export const notifyAiReceptionistSettingsChanged = (
  message = i18next.t(
    "Your settings have been updated. Start a new call to test the AI Receptionist's latest knowledge.",
    { ns: 'ai-receptionist' }
  ),
  settingType?: string
) => {
  const enqueue = useQueueStore.getState().enqueue;

  enqueue('ai-receptionist-test-panel', {
    payload: {
      action: 'settings-changed',
      message,
      settingType,
    },
  });
};
